// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.E9Dldj {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-0-5, 4px);
  font-family: var(--font-family-base);
  font-weight: var(--type-label-sm-regular-font-weight, 400);
  line-height: var(--type-label-sm-regular-line-height, 1.5);
  border-bottom-left-radius: var(--radius-s, 4px);
  border-bottom-right-radius: var(--radius-s, 4px);
  transition: all 0.2s ease;
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
}

/* Size variants */
.Ya6pUU {
  font-size: var(--type-label-xs-font-size, 10px);
  padding: var(--spacing-0-5, 4px) var(--spacing-1, 8px);
  min-height: 18px;
}

.Yymv1I {
  font-size: var(--type-label-sm-font-size, 12px);
  padding: var(--spacing-0-5, 4px) var(--spacing-1-5, 12px);
  min-height: 20px;
}

.OYpnc9 {
  font-size: var(--type-label-md-font-size, 14px);
  padding: var(--spacing-1, 8px) var(--spacing-2, 16px);
  min-height: 24px;
}

/* Rounded variant */
.RuuZ61 {
  border-radius: 999px;
}

/* Outline variant */
.apOmln {
  /* Base outline styles - background will be set per variant */
}

/* Color variants */
.kGtZlf {
  background-color: var(--surface-neutral-subtle, #e5e5e5);
  color: var(--text-neutral-dark, #1f1f1f);
  border: 1px solid var(--stroke-neutral-subtle, #e5e5e5);
}

.v_0zMp {
  background-color: var(--surface-primary-medium, #d64000);
  color: var(--text-neutral-white, #ffffff);
  border: 1px solid var(--stroke-primary-medium, #d64000);
}

.jtvxUj {
  background-color: var(--surface-neutral-pale, #f5f5f5);
  color: var(--text-neutral-stronger, #4a4a4a);
  border: 1px solid var(--stroke-neutral-silver, #cccccc);
}

.hORk6z {
  background-color: var(--status-success, #00a651);
  color: var(--text-neutral-white, #ffffff);
  border: 1px solid var(--status-success, #00a651);
}

.PMHsTs {
  background-color: var(--status-warning, #ffc107);
  color: var(--text-neutral-dark, #1f1f1f);
  border: 1px solid var(--status-warning, #ffc107);
}

.Z4aWRU {
  background-color: var(--status-error, #dc3545);
  color: var(--text-neutral-white, #ffffff);
  border: 1px solid var(--status-error, #dc3545);
}

.S6OFCg {
  background-color: var(--status-info, #007bff);
  color: var(--text-neutral-white, #ffffff);
  border: 1px solid var(--status-info, #007bff);
}

/* Outline color variants */
.apOmln.kGtZlf {
  background-color: var(--surface-neutral-white, #ffffff);
  color: var(--text-neutral-dark, #1f1f1f);
  border-color: var(--stroke-neutral-subtle, #e5e5e5);
}

.apOmln.v_0zMp {
  background-color: var(--surface-primary-subtle, #ffe6d9);
  color: var(--text-primary-medium, #d64000);
  border-color: var(--stroke-primary-medium, #d64000);
}

.apOmln.jtvxUj {
  background-color: var(--surface-neutral-white, #ffffff);
  color: var(--text-neutral-stronger, #4a4a4a);
  border-color: var(--stroke-neutral-silver, #cccccc);
}

.apOmln.hORk6z {
  background-color: var(--surface-neutral-white, #ffffff);
  color: var(--status-success, #00a651);
  border-color: var(--status-success, #00a651);
}

.apOmln.PMHsTs {
  background-color: var(--surface-neutral-white, #ffffff);
  color: var(--status-warning, #ffc107);
  border-color: var(--status-warning, #ffc107);
}

.apOmln.Z4aWRU {
  background-color: var(--surface-neutral-white, #ffffff);
  color: var(--status-error, #dc3545);
  border-color: var(--status-error, #dc3545);
}

.apOmln.S6OFCg {
  background-color: var(--surface-neutral-white, #ffffff);
  color: var(--status-info, #007bff);
  border-color: var(--status-info, #007bff);
}

/* Icon styling */
.zakKvT {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.zakKvT svg,
.zakKvT img {
  width: 12px;
  height: 12px;
}

.Ya6pUU .zakKvT svg,
.Ya6pUU .zakKvT img {
  width: 10px;
  height: 10px;
}

.OYpnc9 .zakKvT svg,
.OYpnc9 .zakKvT img {
  width: 14px;
  height: 14px;
}

/* Content styling */
.DAwjYB {
  display: flex;
  align-items: center;
  font-weight: inherit;
  line-height: inherit;
}

/* Hover effects for interactive badges */
.E9Dldj:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Focus styles for accessibility */
.E9Dldj:focus {
  outline: 2px solid var(--focus-default, #007bff);
  outline-offset: 2px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .OYpnc9 {
    font-size: var(--type-label-sm-font-size, 12px);
    padding: var(--spacing-0-5, 4px) var(--spacing-1-5, 12px);
    min-height: 20px;
  }

  .OYpnc9 .zakKvT svg,
  .OYpnc9 .zakKvT img {
    width: 12px;
    height: 12px;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .E9Dldj {
    border-width: 2px;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  .E9Dldj {
    transition: none;
  }

  .E9Dldj:hover {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Badge/Badge.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;EAC5B,oCAAoC;EACpC,0DAA0D;EAC1D,0DAA0D;EAC1D,+CAA+C;EAC/C,gDAAgD;EAChD,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,+CAA+C;EAC/C,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,yDAAyD;EACzD,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;AAC/D;;AAEA,mBAAmB;AACnB;EACE,wDAAwD;EACxD,wCAAwC;EACxC,uDAAuD;AACzD;;AAEA;EACE,wDAAwD;EACxD,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,sDAAsD;EACtD,4CAA4C;EAC5C,uDAAuD;AACzD;;AAEA;EACE,gDAAgD;EAChD,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;EACE,8CAA8C;EAC9C,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA,2BAA2B;AAC3B;EACE,uDAAuD;EACvD,wCAAwC;EACxC,mDAAmD;AACrD;;AAEA;EACE,wDAAwD;EACxD,0CAA0C;EAC1C,mDAAmD;AACrD;;AAEA;EACE,uDAAuD;EACvD,4CAA4C;EAC5C,mDAAmD;AACrD;;AAEA;EACE,uDAAuD;EACvD,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,uDAAuD;EACvD,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,uDAAuD;EACvD,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,uDAAuD;EACvD,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,mCAAmC;AACnC;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,+CAA+C;IAC/C,yDAAyD;IACzD,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".badge {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-0-5, 4px);\n  font-family: var(--font-family-base);\n  font-weight: var(--type-label-sm-regular-font-weight, 400);\n  line-height: var(--type-label-sm-regular-line-height, 1.5);\n  border-bottom-left-radius: var(--radius-s, 4px);\n  border-bottom-right-radius: var(--radius-s, 4px);\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  text-align: center;\n  vertical-align: middle;\n}\n\n/* Size variants */\n.sm {\n  font-size: var(--type-label-xs-font-size, 10px);\n  padding: var(--spacing-0-5, 4px) var(--spacing-1, 8px);\n  min-height: 18px;\n}\n\n.md {\n  font-size: var(--type-label-sm-font-size, 12px);\n  padding: var(--spacing-0-5, 4px) var(--spacing-1-5, 12px);\n  min-height: 20px;\n}\n\n.lg {\n  font-size: var(--type-label-md-font-size, 14px);\n  padding: var(--spacing-1, 8px) var(--spacing-2, 16px);\n  min-height: 24px;\n}\n\n/* Rounded variant */\n.rounded {\n  border-radius: 999px;\n}\n\n/* Outline variant */\n.outline {\n  /* Base outline styles - background will be set per variant */\n}\n\n/* Color variants */\n.default {\n  background-color: var(--surface-neutral-subtle, #e5e5e5);\n  color: var(--text-neutral-dark, #1f1f1f);\n  border: 1px solid var(--stroke-neutral-subtle, #e5e5e5);\n}\n\n.primary {\n  background-color: var(--surface-primary-medium, #d64000);\n  color: var(--text-neutral-white, #ffffff);\n  border: 1px solid var(--stroke-primary-medium, #d64000);\n}\n\n.secondary {\n  background-color: var(--surface-neutral-pale, #f5f5f5);\n  color: var(--text-neutral-stronger, #4a4a4a);\n  border: 1px solid var(--stroke-neutral-silver, #cccccc);\n}\n\n.success {\n  background-color: var(--status-success, #00a651);\n  color: var(--text-neutral-white, #ffffff);\n  border: 1px solid var(--status-success, #00a651);\n}\n\n.warning {\n  background-color: var(--status-warning, #ffc107);\n  color: var(--text-neutral-dark, #1f1f1f);\n  border: 1px solid var(--status-warning, #ffc107);\n}\n\n.error {\n  background-color: var(--status-error, #dc3545);\n  color: var(--text-neutral-white, #ffffff);\n  border: 1px solid var(--status-error, #dc3545);\n}\n\n.info {\n  background-color: var(--status-info, #007bff);\n  color: var(--text-neutral-white, #ffffff);\n  border: 1px solid var(--status-info, #007bff);\n}\n\n/* Outline color variants */\n.outline.default {\n  background-color: var(--surface-neutral-white, #ffffff);\n  color: var(--text-neutral-dark, #1f1f1f);\n  border-color: var(--stroke-neutral-subtle, #e5e5e5);\n}\n\n.outline.primary {\n  background-color: var(--surface-primary-subtle, #ffe6d9);\n  color: var(--text-primary-medium, #d64000);\n  border-color: var(--stroke-primary-medium, #d64000);\n}\n\n.outline.secondary {\n  background-color: var(--surface-neutral-white, #ffffff);\n  color: var(--text-neutral-stronger, #4a4a4a);\n  border-color: var(--stroke-neutral-silver, #cccccc);\n}\n\n.outline.success {\n  background-color: var(--surface-neutral-white, #ffffff);\n  color: var(--status-success, #00a651);\n  border-color: var(--status-success, #00a651);\n}\n\n.outline.warning {\n  background-color: var(--surface-neutral-white, #ffffff);\n  color: var(--status-warning, #ffc107);\n  border-color: var(--status-warning, #ffc107);\n}\n\n.outline.error {\n  background-color: var(--surface-neutral-white, #ffffff);\n  color: var(--status-error, #dc3545);\n  border-color: var(--status-error, #dc3545);\n}\n\n.outline.info {\n  background-color: var(--surface-neutral-white, #ffffff);\n  color: var(--status-info, #007bff);\n  border-color: var(--status-info, #007bff);\n}\n\n/* Icon styling */\n.icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.icon svg,\n.icon img {\n  width: 12px;\n  height: 12px;\n}\n\n.sm .icon svg,\n.sm .icon img {\n  width: 10px;\n  height: 10px;\n}\n\n.lg .icon svg,\n.lg .icon img {\n  width: 14px;\n  height: 14px;\n}\n\n/* Content styling */\n.content {\n  display: flex;\n  align-items: center;\n  font-weight: inherit;\n  line-height: inherit;\n}\n\n/* Hover effects for interactive badges */\n.badge:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Focus styles for accessibility */\n.badge:focus {\n  outline: 2px solid var(--focus-default, #007bff);\n  outline-offset: 2px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .lg {\n    font-size: var(--type-label-sm-font-size, 12px);\n    padding: var(--spacing-0-5, 4px) var(--spacing-1-5, 12px);\n    min-height: 20px;\n  }\n\n  .lg .icon svg,\n  .lg .icon img {\n    width: 12px;\n    height: 12px;\n  }\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n  .badge {\n    border-width: 2px;\n  }\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n  .badge {\n    transition: none;\n  }\n\n  .badge:hover {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `E9Dldj`,
	"sm": `Ya6pUU`,
	"md": `Yymv1I`,
	"lg": `OYpnc9`,
	"rounded": `RuuZ61`,
	"outline": `apOmln`,
	"default": `kGtZlf`,
	"primary": `v_0zMp`,
	"secondary": `jtvxUj`,
	"success": `hORk6z`,
	"warning": `PMHsTs`,
	"error": `Z4aWRU`,
	"info": `S6OFCg`,
	"icon": `zakKvT`,
	"content": `DAwjYB`
};
module.exports = ___CSS_LOADER_EXPORT___;
